// Lazy-loaded to keep the initial bundle small (same pattern as reception).
const TimeslotListView = () => import("../presentation/views/TimeslotListView.vue");
const AppointmentListView = () => import("../presentation/views/AppointmentListView.vue");
const AppointmentRescheduleEscalationView = () => import("../presentation/views/AppointmentRescheduleEscalationView.vue");
// The module belongs to the social worker (AGS-US-004, epic 02): only OpsolSocialWorker carries
// opsol.scheduling (BFF PermissionHelper.SchedulingCapability). The reception agent and the phone
// operator keep the whole appointment surface from their own journey instead — this gate closes the
// module, not the appointment surface.
// DELIBERATE ASYMMETRY (OP-7807): OPAGD's SchedulingPolicy still admits OpsolDivisionManager, where
// it is load-bearing for the confidentiality rule (OP-7576) and must stay. An RC therefore keeps
// every server-side right that policy carries while losing BOTH tabs here.
// Do not "align" one side onto the other; the converse note lives on SchedulingPolicy in
// eudonet-opagd AuthorizationServiceExtension. Consequence: this particular gate is UI scoping, not
// a security boundary — OPAGD has no opsol.scheduling equivalent, so every persona its own policies
// admit keeps those server-side rights whatever the portal hides.
const SCHEDULING_META = {
    requiresAuth: true,
    titleKey: "scheduling.pageTitle",
    requiresCapability: "opsol.scheduling",
};
const SlotTypeCatalogueView = () => import("../presentation/views/SlotTypeCatalogueView.vue");
export const schedulingRoutes = [
    {
        // Settings surface, not part of the social worker's module: gated on the Access Manager role
        // rather than on SCHEDULING_META's opsol.scheduling. `accessmanager.manage-users` is that
        // role's ONLY projection (BFF PermissionHelper: AccessManager -> [ManageUsersCapability]), so
        // despite its name it reads here as "holds the AccessManager role", not as a claim about users.
        // OPAGD enforces it independently with opagd-admin-policy; this gate is UI scoping.
        path: "/module/slot-types",
        name: "SlotTypeCatalogue",
        component: SlotTypeCatalogueView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "scheduling.slotTypes.title",
        },
    },
    {
        // Bare /scheduling was the Timeslots route's own path until the two tabs got symmetric
        // sub-paths — kept as a redirect so old bookmarks/links still land somewhere, on the tab
        // users expect to see first rather than Timeslots.
        path: "/scheduling",
        redirect: { name: "SchedulingAppointments" },
    },
    {
        path: "/scheduling/timeslots",
        name: "SchedulingTimeslots",
        component: TimeslotListView,
        meta: { ...SCHEDULING_META },
    },
    {
        path: "/scheduling/appointments",
        name: "SchedulingAppointments",
        component: AppointmentListView,
        meta: { ...SCHEDULING_META },
    },
    {
        path: "/scheduling/appointments/reschedule-escalation",
        name: "SchedulingRescheduleEscalation",
        component: AppointmentRescheduleEscalationView,
        // Outside the module gate on purpose: reached by router.push from a caller that already holds
        // the appointment, never from the menu. Requiring opsol.scheduling here would break the
        // reception agent's own rescheduling journey (AGS-US-012).
        meta: { ...SCHEDULING_META, requiresCapability: "opsol.read" },
    },
];
// CONSTRAINT: this entry carries NO capability, and nothing renders it today —
// moduleRegistry.getNavigationItems() has no consumer but a TODO in SettingsSidebar. Wiring that
// TODO without adding the module gate here would put "Rendez-vous & plages" back in front of all
// four OPSOL personas, silently: the routes would still 403, but the affordance would be offered.
// The gate that is actually enforced lives on schedulingEntry in MainSidebar.vue.
export const schedulingNavigationItems = [
    {
        labelKey: "scheduling.pageTitle",
        // Lands on the Appointments tab (SchedulingTabs' default) rather than /scheduling itself,
        // which renders the Timeslots tab — the appointments list is what users expect to see first.
        path: "/scheduling/appointments",
        meta: { requiresAuth: true },
    },
];
